import MobileTableActions from './MobileTableActions';

const MobileTableBody = ({
  data,
  columns,
  actions,
  noDataMessage,
}) => {
  // ────────────────────────────────────────────
  // SIN DATOS
  // ────────────────────────────────────────────

  if (!data || data.length === 0) {
    return (
      <p
        className="
          py-6
          text-center
          text-sm

          text-body
          dark:text-bodydark
        "
      >
        {noDataMessage}
      </p>
    );
  }

  // ────────────────────────────────────────────
  // Resolver acciones
  // ────────────────────────────────────────────

  const resolveActions = (row) => {
    if (!actions) {
      return [];
    }

    if (typeof actions === 'function') {
      return actions(row) ?? [];
    }

    if (Array.isArray(actions)) {
      return actions;
    }

    return [];
  };

  // ────────────────────────────────────────────
  // Render
  // ────────────────────────────────────────────

  return (
    <div className="flex flex-col gap-3">
      {data.map((row) => (
        <div
          key={row.id}
          className="
            rounded-xl

            border
            border-stroke

            bg-white

            p-4

            shadow-1

            dark:border-strokedark
            dark:bg-boxdark
          "
        >
          {columns.map((col) => (
            <div
              key={col.accessor}
              className="mb-3 last:mb-0"
            >
              <span
                className="
                  mb-1
                  block

                  text-[11px]
                  font-medium
                  uppercase
                  tracking-wider

                  text-body
                  dark:text-bodydark
                "
              >
                {col.label}
              </span>

              <span
                className="
                  block

                  text-sm
                  font-medium

                  text-black
                  dark:text-white
                "
              >
                {col.render
                  ? col.render(row)
                  : row[col.accessor] ?? '—'}
              </span>
            </div>
          ))}

          <MobileTableActions
            row={row}
            actions={resolveActions(row)}
          />
        </div>
      ))}
    </div>
  );
};

export default MobileTableBody;